import { Pipe, PipeTransform } from "@angular/core";
import {
  IWorkorderOrServiceRequestSummary,
  IWorkorderRequestSummary,
  RequestSourceTypeEnum,
} from "../models/request";
import { CurrentUserService } from "../services/current-user.service";

@Pipe({
  name: "canUpdateActivity",
})
export class CanUpdateActivityPipe implements PipeTransform {
  constructor(private currentUserService: CurrentUserService) {}

  transform(request: IWorkorderOrServiceRequestSummary): boolean {
    const hasActivityForm = this.currentUserService.hasActivityForm(
      request.service.code,
    );
    const isUserSameBoroughAsRequest =
      this.currentUserService.isUserSameBoroughAsRequest(request.borough.code);
    if (request.source === RequestSourceTypeEnum.workorderRequest) {
      return (
        !(request as IWorkorderRequestSummary).hasExistingTask &&
        !hasActivityForm &&
        isUserSameBoroughAsRequest
      );
    }
    return !hasActivityForm && isUserSameBoroughAsRequest;
  }
}
